import React from 'react'
import styles from './MandatoryQuestion.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'

interface IMandatoryQuestion {
  customText?: string,
  show?: boolean
}

const MandatoryQuestion: React.FC<IMandatoryQuestion> = ({ customText = '' , show = false }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.minHeight}>
      <div className={`${show ? 'd-flex' : 'd-none'} align-items-center`}>
        <FontAwesomeIcon className={styles.icon} icon={faTimesCircle} />
        <p className={`${styles.text} ml-1 m-0`}> {customText ? customText : t('lessons.mandatory')}</p>
      </div>
    </div>
  )
}

export default MandatoryQuestion
